import { HttpInterceptorFn } from "@angular/common/http";
import { TOKEN_STORE } from "../services/auth.service";
import { environment } from "../../../environments/environment";

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authToken = req.url === `${environment.urls.api}auth/exchange`
    ? JSON.parse(localStorage.getItem('okta-token-storage') || '{}')?.idToken?.idToken
    : localStorage.getItem(TOKEN_STORE);
  if (authToken) {
    req = req.clone({
      headers: req.headers.set('Authorization', `Bearer ${authToken}`)
    });
  }

  return next(req);
}

